var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-portal", [
    _c("div", { staticClass: "dashboard-page p-0" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c(
          "div",
          { staticClass: "order-2" },
          [
            _c("dashboard-list", {
              staticClass: "p-md-3",
              attrs: { showImage: false, listClass: "col-sm-6 col-xl-4" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "order-1" }, [
          _c(
            "div",
            {
              staticClass: "card dashboard-help border-0 bg-transparent p-md-3",
            },
            [
              _c("div", { staticClass: "card-body px-0 pt-0" }, [
                _c("h1", { staticClass: "card-title content-title" }, [
                  _vm._v(
                    "\n                            Dashboard\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v(
                    "Bem-vindo ao CityHub.pt. Através do dashboard pode aceder a diversas ferramentas de gestão do seu município."
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v(
                    "Fique rápidamente a par das suas notificações e mensagens. Aqui é onde tudo começa."
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v(
                    "Queremos ajudá-lo a criar um município ainda melhor."
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }